import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { scheduleWorkspaceClosure } from '@/api/workspaceClosure/workspaceClosureApi';
import type { WorkspaceClosure } from '@/api/workspaceClosure/workspaceClosureApi.types';
import { WORKSPACE_CLOSURE_QUERY_KEY } from '@/constants/queryKeys';

export function useScheduleWorkspaceClosureMutation(): UseMutationResult<
  WorkspaceClosure,
  Error,
  string
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: scheduleWorkspaceClosure,
    onSuccess: function storeScheduledClosure(workspaceClosure) {
      queryClient.setQueryData(WORKSPACE_CLOSURE_QUERY_KEY, workspaceClosure);
    },
  });
}
